import { post } from "./api"
import { logEvent } from "./amplitude"

const logDownloadEventToAmplitude = (slideshow, eventName, eventSource) => {
  let eventOptions = {
    slideshow_id: slideshow.id,
    source: eventSource || window.location.pathname,
  }

  logEvent(eventName, eventOptions)
}

export const handleDownload = async (slideshow, path, source) => {
  logDownloadEventToAmplitude(slideshow, "slideshow_download_attempt", source)
  const result = await post(path)
  logDownloadEventToAmplitude(slideshow, "slideshow_download_init", source)

  const iframe = document.createElement("iframe")
  iframe.src = result.data.url
  iframe.style.display = "none"

  document.body.appendChild(iframe)

  return result
}
